import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-third-pillar-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6753_2480)">
        <path
          d="M8.78404 17.2922C8.94539 17.4145 9.07813 17.5706 9.173 17.7496C9.26787 17.9285 9.3226 18.1259 9.33337 18.3282V28.6455C9.32167 28.8489 9.26688 29.0476 9.17264 29.2282C9.0784 29.4089 8.94685 29.5675 8.78671 29.6935L5.88004 31.7215C5.71614 31.824 5.52671 31.8784 5.33337 31.8784C5.14004 31.8784 4.95061 31.824 4.78671 31.7215L1.88004 29.6935C1.71964 29.5677 1.58792 29.4092 1.49365 29.2285C1.39938 29.0478 1.34474 28.849 1.33337 28.6455V18.3282C1.34478 18.1255 1.40034 17.9278 1.49614 17.7488C1.59195 17.5699 1.7257 17.414 1.88804 17.2922L4.77871 15.3642C4.94662 15.2647 5.1382 15.2122 5.33337 15.2122C5.52855 15.2122 5.72013 15.2647 5.88804 15.3642L8.78404 17.2922Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.33862 20.3282L1.49329 17.7642"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.18396 17.7642L5.33862 20.3282"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.33862 20.3281V31.8415"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.4507 9.95891C19.612 10.0813 19.7448 10.2374 19.8396 10.4163C19.9345 10.5952 19.9892 10.7927 20 10.9949V28.6456C19.9883 28.849 19.9335 29.0476 19.8393 29.2283C19.745 29.409 19.6135 29.5676 19.4533 29.6936L16.5467 31.7216C16.3828 31.8241 16.1933 31.8785 16 31.8785C15.8067 31.8785 15.6172 31.8241 15.4533 31.7216L12.5467 29.6936C12.3863 29.5678 12.2545 29.4093 12.1603 29.2286C12.066 29.0478 12.0114 28.8491 12 28.6456V10.9949C12.012 10.7918 12.0684 10.5938 12.1652 10.4148C12.2619 10.2359 12.3967 10.0802 12.56 9.95891L15.4507 8.03091C15.6186 7.93141 15.8102 7.87891 16.0053 7.87891C16.2005 7.87891 16.3921 7.93141 16.56 8.03091L19.4507 9.95891Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0054 12.9949L12.16 10.4309"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.8507 10.4309L16.0054 12.9949"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0054 12.9949V31.8629"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.1173 3.95891C30.2786 4.0813 30.4114 4.23739 30.5063 4.41631C30.6011 4.59523 30.6559 4.79268 30.6666 4.99491V28.6456C30.6549 28.849 30.6001 29.0476 30.5059 29.2283C30.4117 29.409 30.2801 29.5676 30.12 29.6936L27.2133 31.7216C27.0494 31.8241 26.86 31.8785 26.6666 31.8785C26.4733 31.8785 26.2839 31.8241 26.12 31.7216L23.2133 29.6936C23.0529 29.5678 22.9212 29.4093 22.8269 29.2286C22.7326 29.0478 22.678 28.8491 22.6666 28.6456V4.99491C22.678 4.79225 22.7336 4.59452 22.8294 4.41557C22.9252 4.23662 23.059 4.08077 23.2213 3.95891L26.1173 2.03091C26.2852 1.93141 26.4768 1.87891 26.672 1.87891C26.8671 1.87891 27.0587 1.93141 27.2266 2.03091L30.1173 3.95891Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.672 6.99491L22.8267 4.43091"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.5173 4.43091L26.672 6.99491"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.672 6.99487V31.8629"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6753_2480">
          <rect width="32" height="32" fill="white" transform="translate(0 0.878906)" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class ThirdPillarInsuranceIconComponent extends BaseIconComponent {}
